import React, { useEffect, useMemo, useState } from "react";
import { Icon } from "@iconify/react";
import { TableContainer } from "@mui/material";
import { thStyle, tdStyle, inputStyle } from "../addstock/tableStyles";
import { Button, Typography, TextField } from "@mui/material";
import style from "./Customer.module.css";
import CustomerTable from "./customer";
import { LotAuditColumns, PartyOutstandingColumns, selectStyle } from "utils/helpers";
import { fetchLotAuditReports, partyOutstandingReports } from "services/invoiceServices";
import { useQuery } from "@tanstack/react-query";
import { Controller, useForm } from "react-hook-form";
import { FaSearch } from "react-icons/fa";
import Select from "react-select";
import useDebounce from "hooks/useDebounce";
import toast from "react-hot-toast";
import PageLoader from "Components/PageLoader";
export default function PartyOutstandingReport({
  clientCode,
  allCategories,
  allVendors,
}) {
  const { data: partyOutstandingList,isLoading,isError } = useQuery({
    queryKey: ["purchaseReport/PartyOutstanding", clientCode],
    queryFn: partyOutstandingReports,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });

  console.log(partyOutstandingList)

  const {
    register,
    watch,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      SearchQuery: "",
      stockType: "",
      category: "",
      vendor: "",
    },
  });
  const stockType = watch("stockType");
  const category = watch("category");
  const vendor = watch("vendor");
  const SearchQuery = watch("SearchQuery");
  const debouncedSearchQuery = useDebounce(SearchQuery,1500)
  const [loading, setLoading] = useState(false);


  
  useEffect(()=>{
    if(isError){
      toast.error("Failed to fetch report, trye again later", {
        duration: 3000,
        position: "center"
      });
    }
  },[isError])

  const filteredData = useMemo(() => {
    setLoading(true)
    let result = partyOutstandingList?.map((item)=>{
        return {
            ...item,
            TotalBalanceSilver:(+(item?.TotalBalanceSilver || 0))?.toFixed(3),
            TotalBalanceGold:(+(item?.TotalBalanceSilver || 0))?.toFixed(3),
            TotalBalanceAmount:(+(item?.TotalBalanceAmount || 0))?.toFixed(2),
            TotalAdvanceAmount:(+(item?.TotalAdvanceAmount || 0))?.toFixed(2),

        }
    });
   

    // if (stockType?.value == "Labelled") {
    //   result = partyOutstandingList?.filter((item) => item?.StatusType);
    // }
    // if (stockType?.value == "Unlabelled") {
    //   result = partyOutstandingList?.filter((item) => !item?.StatusType);
    // }

    if (vendor?.value) {
      result = result?.filter((item) => item?.VendorName == vendor?.value);
    }

    if (debouncedSearchQuery) {
      result = result.filter(
        (item) =>
          item?.VendorName?.toLowerCase().includes(debouncedSearchQuery.toLowerCase())
      );
    }
    setLoading(false)
    return result;
  }, [partyOutstandingList, 
    // stockType, 
    category, vendor,debouncedSearchQuery]);

 
  

  const  dropdown = (data,key)=>{
    let result = []
    if(key == "category"){
     result =   data?.map((x) => ({
        value: x.Id,
        label: x.CategoryName,
      })) || [];
    }
    if(key == "vendor"){
    result =  data?.map((x) => ({
        value: x.VendorName,
        label: x.VendorName,
      })) || [];
    }
    if(key == "stockType"){
    result =  [{ value: "Labelled", label: "Labelled" },
      { value: "Unlabelled", label: "Unlabelled" }]
    }
    return  [{ value: "", label: "-- select --" }].concat(result)
  }
  return (
    <>
     {isLoading || loading && (
      <PageLoader />
     )}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "10px 10px 8px 10px",
        }}
      >
        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          {/* Stock Type */}
          {/* <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
            }}
          >
            <label style={{ fontSize: "14px", marginBottom: "4px" }}>
              Stock Type
            </label>

            <Controller
              name={"stockType"}
              control={control}
              render={({ field: controllerField }) => (
                <Select
                  {...controllerField}
                  options={dropdown([],"stockType")}
                  placeholder="-- select --"
                  // {...register("stockType")}
                  styles={{ control: (base) => ({ ...base }) }}
                  isClearable={true}
                />
              )}
            />
          </div> */}

                {/* Vendor */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
            }}
          >
            <label style={{ fontSize: "14px", marginBottom: "4px" }}>
              Vendor
            </label>
            <Controller
              name={"vendor"}
              control={control}
              render={({ field: controllerField }) => (
                <Select
                  {...controllerField}
                  options={dropdown(allVendors,"vendor")}
                  placeholder="-- select --"
                  // {...register("vendor")}
                  styles={{ control: (base) => ({ ...base }) }}
                  isClearable={true}
                />
              )}
            />
          </div>
        </div>

        {/* Search Input */}
        <div
          style={{
            borderRadius: "50px",
            padding: "2px 10px",
            border: "1px solid gray",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "6px",
          }}
        >
          <FaSearch />
          <input
            {...register("SearchQuery")}
            placeholder="Search"
            style={{
              background: "#fff",
              outline: "none",
              border: "none",
              boxShadow: "none",
            }}
          />
        </div>
      </div>
    
      <CustomerTable
        columns={PartyOutstandingColumns}
        allCategories={filteredData?.length ? filteredData : []}
        handleEditData={() => {}}
        handlePrint={(product) => console.log(product)}
        searchInput={""}
        setSearchInput={() => {}}
      />
    </>
  );
}
